import {classNames, IconNames, MaterialIcon, theme} from "@variocube/cube-ui";
import {Component} from "react";
import {stylesheet} from "typestyle";
import * as React from 'react';

interface BoxItemProps {
    number: string;
    open?: boolean;
    onClick?: () => void;
    checked?: boolean;
    className?: string;
}

export class BoxItem extends Component<BoxItemProps> {
    render() {
        const {number, open, onClick, checked, className} = this.props;
        return (
            <div className={classNames(theme.moreContrast, styles.boxItem, checked && styles.boxItemChecked, className)} onClick={onClick}>
                {number}
                <MaterialIcon icon={open ? IconNames.lock_open : IconNames.lock} className={styles.lockIcon}/>
            </div>
        )
    }
}

const styles = stylesheet({
    boxItem: {
        border: "0.25rem solid var(--color-choice)",
        width: "10rem",
        height: "10rem",
        fontSize: "3em",
        textAlign: "center",
        lineHeight: "10rem",
        position: "relative",
        fontWeight: "bold",
    },
    boxItemChecked: {
        backgroundColor: "var(--color-choice)",
    },
    lockIcon: {
        position: "absolute",
        right: "-1rem",
        bottom: "-1rem",
        lineHeight: 1,
        filter: "drop-shadow(0 0 0.25rem #000)"
    }
});